import React, { useMemo } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { SALESFORCE_URL_PREFIX } from 'apps/marketplace/utils/constants/salesforceUrl'
import { IAwardedLaneFragment } from '../../../../graphql/AwardedLaneFragment'
import { ISidebarListDataItem } from '../SidebarListData'

const formatRate = (rate: Maybe<number>): string | null =>
  rate ? `$${Number(rate).toFixed(2)}` : null

interface IRateMetricsProps
  extends Pick<IAwardedLaneFragment, 'carrierMarketRate' | 'requestForProposalLaneFeedback'> {
  isDisplayStormUrl: boolean
}

export const useRateMetrics = ({
  carrierMarketRate,
  isDisplayStormUrl,
  requestForProposalLaneFeedback,
}: IRateMetricsProps): ISidebarListDataItem[] =>
  useMemo(() => {
    const { requestForProposalLanePrice, tttAtAward } = requestForProposalLaneFeedback ?? {}
    const { requestForProposalLane, tfxhAllIn } = requestForProposalLanePrice ?? {}
    const { requestForProposal } = requestForProposalLane ?? {}
    const { auditWorkspace, googleSheetsUrl, id, salesforceRfpId } = requestForProposal ?? {}

    return [
      {
        label: 'Salesforce RFP ID',
        value: (
          <a
            href={`${SALESFORCE_URL_PREFIX}${salesforceRfpId}/view`}
            target='_blank'
            rel='noopener noreferrer'>
            {salesforceRfpId}
          </a>
        ),
      },
      auditWorkspace && isDisplayStormUrl
        ? {
            label: 'Contract Pricing Workspace',
            value: (
              <a href={`${__ROOT__}/rfp/${id}`} target='_blank' rel='noopener noreferrer'>
                {id}
              </a>
            ),
          }
        : {
            label: 'Google Sheets URL',
            value: (
              <a href={googleSheetsUrl ?? '#'} target='_blank' rel='noopener noreferrer'>
                Google Sheets URL
              </a>
            ),
          },
      {
        label: 'All In',
        value: formatRate(tfxhAllIn),
      },
      {
        label: 'Carrier Market Rate',
        value: formatRate(carrierMarketRate),
      },
      {
        label: 'TTT At Award',
        value: formatRate(tttAtAward),
      },
    ]
  }, [carrierMarketRate, requestForProposalLaneFeedback])
